import React from 'react'

const PDFJS_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js'
const PDFJS_WORKER = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js'

function loadPdfJs() {
  return new Promise((resolve) => {
    if (window.pdfjsLib) return resolve(window.pdfjsLib)
    const script = document.createElement('script')
    script.src = PDFJS_CDN
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER
      resolve(window.pdfjsLib)
    }
    document.head.appendChild(script)
  })
}

export async function loadPdfPages(dataUrl) {
  const pdfjsLib = await loadPdfJs()
  const pdf = await pdfjsLib.getDocument(dataUrl).promise
  const pages = []
  for (let i = 1; i <= pdf.numPages; i++) {
    const page = await pdf.getPage(i)
    const viewport = page.getViewport({ scale: 1.5 })
    const canvas = document.createElement('canvas')
    canvas.width = viewport.width
    canvas.height = viewport.height
    await page.render({ canvasContext: canvas.getContext('2d'), viewport }).promise
    pages.push(canvas.toDataURL())
  }
  return pages
}

export default function PdfPreview({ pages }) {
  if (!pages || pages.length === 0) return null
  return (
    <div style={{ marginTop: '12px', border: '1px solid #dee2e6', borderRadius: '6px', overflow: 'hidden' }}>
      {pages.map((src, i) => (
        <img key={i} src={src} alt={`Page ${i + 1}`} style={{ width: '100%', display: 'block', borderTop: i > 0 ? '1px solid #dee2e6' : 'none' }} />
      ))}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Wps/PdfPreview.js